module.exports = __webpack_public_path__ + "static/media/viande.fea9848b.svg";